import { showSearchModal } from '../uiManager/UiSearchModal';
import { searchEmployees as apiSearchEmployees, searchPartners as apiSearchPartners, } from '../../apis/fieldSurveyRequestApi';
import { graphqlQuery } from '../../apis/graphqlClient';
import { getAllZone, getAllDo } from '../../data/zodoData';
function setFormValue(id, value) {
    const el = document.getElementById(id);
    if (el)
        el.value = value;
}
// ZO/DO コードを名称に変換（マスタ未取得・未登録の場合はコードをそのまま表示）
function withZoDoNames(items) {
    const zoData = getAllZone().zone_data;
    const doData = getAllDo().do_data;
    const zoNames = {};
    const doNames = {};
    for (const key in zoData)
        zoNames[zoData[key].zone_code] = zoData[key].zone_name;
    for (const key in doData)
        doNames[doData[key].do_code] = doData[key].do_name;
    return items.map(item => ({
        ...item,
        zoName: zoNames[item.zo] || item.zo,
        doName: doNames[item.do] || item.do,
    }));
}
// --- Search functions (GraphQL API) ---
async function searchCandidates(conditions) {
    const query = `
    query candidateSearch($input: CandidateSearchInput) {
      candidateSearch(input: $input) {
        totalCount
        items {
          candidateId
          storeName
          storeNameKana
          prefectureCode
          prefectureName
          zo
          do
          address
          contractTypeCode
          contractTypeName
          ownershipCode
          ownershipName
        }
      }
    }
  `;
    try {
        const input = {};
        if (conditions.candidateId)
            input.candidateId = conditions.candidateId;
        if (conditions.storeName)
            input.storeName = conditions.storeName;
        const data = await graphqlQuery(query, { input });
        return withZoDoNames(data.candidateSearch.items || []);
    }
    catch {
        return [];
    }
}
async function searchStores(conditions) {
    const query = `
    query storeSearch($input: StoreSearchInput) {
      storeSearch(input: $input) {
        totalCount
        items {
          storeNo
          storeName
          storeNameKana
          prefectureCode
          prefectureName
          zo
          do
          address
          contractTypeCode
          contractTypeName
          ownershipCode
          ownershipName
          dmCode
          dmName
        }
      }
    }
  `;
    try {
        const input = {};
        if (conditions.storeNo)
            input.storeNo = conditions.storeNo;
        if (conditions.storeName)
            input.storeName = conditions.storeName;
        const data = await graphqlQuery(query, { input });
        return withZoDoNames(data.storeSearch.items || []);
    }
    catch {
        return [];
    }
}
// 職位は職種コードから算出（M:230 / GM:101,102 / DM:210）。サーバー側で変換して返却
const EMPLOYEE_POSITIONS = ['M', 'GM', 'DM'];
// 種別ごとの職位プルダウン（固定値があれば初期選択＋非活性）
// 固定の場合は表示のみ（value は画面用。サーバーへは position を送らず searchType で絞る）
const EMPLOYEE_POSITION_BY_TYPE = {
    REQUESTER: { options: EMPLOYEE_POSITIONS.map(p => ({ value: p, label: p })) },
    APPROVER: { options: [{ value: 'M_GM', label: 'M / GM' }], fixed: 'M_GM' },
    DM: { options: [{ value: 'DM', label: 'DM' }], fixed: 'DM' },
};
function createSearchEmployeesApi(searchType) {
    return async (conditions) => {
        try {
            const results = await apiSearchEmployees({
                departmentName: conditions.departmentName || undefined,
                employeeName: conditions.employeeName || undefined,
                position: EMPLOYEE_POSITION_BY_TYPE[searchType].fixed ? undefined : conditions.position || undefined,
                searchType,
            });
            return results.map(e => ({
                employeeCode: e.employeeCode,
                employeeName: e.employeeName,
                departmentName: e.departmentName,
                position: e.position || '',
            }));
        }
        catch {
            return [];
        }
    };
}
async function searchPartnersApi(conditions) {
    try {
        const results = await apiSearchPartners({
            partnerName: conditions.partnerName || undefined,
            partnerType: conditions.partnerType || undefined,
        });
        return results.map(v => ({
            partnerCode: v.partnerCode,
            partnerName: v.partnerName,
            partnerType: v.partnerType,
        }));
    }
    catch {
        return [];
    }
}
// --- Public API ---
export function openCandidateSearch() {
    showSearchModal({
        title: '候補地検索',
        note: '※モック：候補地番号「A」、店名「新店」などを入力すると結果が表示されます。',
        dialogWidth: '1400px',
        fields: [
            { key: 'candidateId', label: '候補地番号', type: 'text', placeholder: '(半角英数字)' },
            { key: 'storeName', label: '店名', type: 'text', placeholder: '' },
        ],
        columns: [
            { key: 'candidateId', label: '候補地番号', width: '100px' },
            { key: 'storeName', label: '店名', width: '150px' },
            { key: 'storeNameKana', label: 'カナ', width: '150px' },
            { key: 'prefectureName', label: '都道府県', width: '80px' },
            { key: 'zoName', label: 'ZO', width: '90px' },
            { key: 'doName', label: 'DO', width: '90px' },
            { key: 'address', label: '住所' },
            { key: 'contractTypeName', label: '契約タイプ', width: '90px' },
            { key: 'ownershipName', label: '所有区分', width: '80px' },
        ],
        onSearch: searchCandidates,
        onSelect: (data) => {
            setFormValue('txtCandidateId', data.candidateId);
            setFormValue('txtStoreName', data.storeName);
            setFormValue('txtStoreNameKana', data.storeNameKana);
            setFormValue('selPrefecture', data.prefectureCode);
            setFormValue('selZO', data.zo);
            setFormValue('selDO', data.do);
            setFormValue('txtAddress', data.address);
            setFormValue('selContractType', data.contractTypeCode);
            setFormValue('selOwnership', data.ownershipCode);
        },
    });
}
export function openStoreSearch() {
    showSearchModal({
        title: '店舗検索',
        note: '※モック：店番「0」、店名「テスト」などを入力すると結果が表示されます。',
        dialogWidth: '1400px',
        fields: [
            { key: 'storeNo', label: '店番', type: 'text', placeholder: '(半角数字)' },
            { key: 'storeName', label: '店名', type: 'text', placeholder: '' },
        ],
        columns: [
            { key: 'storeNo', label: '店番', width: '70px' },
            { key: 'storeName', label: '店名', width: '150px' },
            { key: 'storeNameKana', label: 'カナ', width: '150px' },
            { key: 'prefectureName', label: '都道府県', width: '80px' },
            { key: 'zoName', label: 'ZO', width: '90px' },
            { key: 'doName', label: 'DO', width: '90px' },
            { key: 'address', label: '住所' },
            { key: 'contractTypeName', label: '契約タイプ', width: '90px' },
            { key: 'ownershipName', label: '所有区分', width: '80px' },
            { key: 'dmName', label: 'DM', width: '90px' },
        ],
        onSearch: searchStores,
        onSelect: (data) => {
            setFormValue('txtStoreNo', data.storeNo);
            setFormValue('txtStoreName', data.storeName);
            setFormValue('txtStoreNameKana', data.storeNameKana);
            setFormValue('selPrefecture', data.prefectureCode);
            setFormValue('selZO', data.zo);
            setFormValue('selDO', data.do);
            setFormValue('txtAddress', data.address);
            setFormValue('selContractType', data.contractTypeCode);
            setFormValue('selOwnership', data.ownershipCode);
            setFormValue('txtDmCode', data.dmCode);
            setFormValue('txtDm', data.dmName);
        },
    });
}
export function openEmployeeSearch(nameFieldId, codeFieldId, searchType) {
    const positionSetting = EMPLOYEE_POSITION_BY_TYPE[searchType];
    showSearchModal({
        title: '社員検索',
        note: '※モック：所属名「部」、社員名「山田」などを入力すると結果が表示されます。',
        fields: [
            { key: 'departmentName', label: '所属名', type: 'text', placeholder: '' },
            { key: 'employeeName', label: '社員名', type: 'text', placeholder: '' },
            {
                key: 'position', label: '職位', type: 'select', options: positionSetting.options,
                defaultValue: positionSetting.fixed, disabled: positionSetting.fixed !== undefined,
            },
        ],
        columns: [
            { key: 'employeeCode', label: '社員コード', width: '90px' },
            { key: 'employeeName', label: '社員名', width: '35%' },
            { key: 'departmentName', label: '所属名', width: '45%' },
            { key: 'position', label: '職位', width: '60px' },
        ],
        onSearch: createSearchEmployeesApi(searchType),
        onSelect: (data) => {
            setFormValue(nameFieldId, data.employeeName);
            setFormValue(codeFieldId, data.employeeCode);
        },
    });
}
export function openVendorSearch(nameFieldId, codeFieldId) {
    showSearchModal({
        title: '取引先検索',
        note: '※モック：取引先名「設計」などを入力するか、取引先区分を選ぶと結果が表示されます。',
        fields: [
            { key: 'partnerName', label: '取引先名', type: 'text', placeholder: '' },
            { key: 'partnerType', label: '取引先区分', type: 'select', options: [
                    { value: '設計事務所', label: '設計事務所' },
                    { value: 'コンサルタント', label: 'コンサルタント' },
                ] },
        ],
        columns: [
            { key: 'partnerCode', label: '取引先コード', width: '100px' },
            { key: 'partnerName', label: '取引先名', width: '60%' },
            { key: 'partnerType', label: '取引先区分', width: '120px' },
        ],
        onSearch: searchPartnersApi,
        onSelect: (data) => {
            setFormValue(nameFieldId, data.partnerName);
            setFormValue(codeFieldId, data.partnerCode);
        },
    });
}
